import { Grid } from "@mui/material";
import ShowTable from "../../../tables/showTable";
import "../../styles.css";
import LaddaButton from "../../../buttons/laddaButton";
import { icons } from "../../../../constants";
import { downloadExcelReport, downloadWordReport } from '../../helpers'

export const InventoryFeedback = ({ data }) => {
  const {
    yearParam,
    attempted = 0,
    inserted = 0,
    updated = 0,
    failures = [],
    failedInserts = 0
  } = data || {};

  const columns = [
    { header: "Fila", field: "row", width: "80px", alignHeader: "left", sortable: true },
    { header: "# Col", field: "columnIndex", width: "80px", alignHeader: "left", sortable: true },
    { header: "Columna", field: "columnTitle", width: "200px", sortable: true },
    { header: "Mensaje", field: "message", width: "320px", sortable: true }
  ];

  const handleDownloadExcel = () => downloadExcelReport(data);
  const handleDownloadWord  = () => downloadWordReport(data);

  const tooMany = failures.length > 2000; 
  return (
    <div style={{ display: "grid", gap: 12 }}>
      <Grid justifyContent="space-between" container spacing={1.5}>
        <Grid item xs={12} md={8}>
          <div className="container-blue p-10 w-fit-content m-5">
            {yearParam != null && <p style={{ margin: "4px 0", opacity: 0.8 }}>Año: <strong className="text-blue">{yearParam}</strong> · </p>}
            <p style={{ margin: "4px 0", opacity: 0.8 }}>Intentados: <strong className="text-grey">{attempted}</strong></p>
            <p style={{ margin: "4px 0", opacity: 0.8 }}>Insertados: <strong className="text-green">{inserted}</strong></p>
            <p style={{ margin: "4px 0", opacity: 0.8 }}>Actualizados: <strong className="text-green">{updated}</strong></p>
            <p style={{ margin: "4px 0", opacity: 0.8 }}>Fallidos: <strong className="text-red">{failedInserts}</strong></p>
            {tooMany && (
              <p style={{ margin: "4px 0", color: "#b85c00" }}>
                Hay muchas fallas ({failures.length}). El reporte se descargará en <strong>modo compacto</strong> con resumen agregado.
              </p>
            )}
          </div>
        </Grid>

        <Grid item xs={12} md={4} style={{ display: "flex", gap: 8, alignItems: "center", justifyContent: "flex-end" }}>
          <LaddaButton variant="contained" onClick={handleDownloadExcel}>
            <div className="IHContainer align-center">
              {icons?.upload && <img className="btn-icon" src={icons.upload} alt="Descargar" style={{ marginRight: 10 }} />}
              <p>Descargar Excel</p>
            </div>
          </LaddaButton>
        </Grid>
      </Grid>

      <section>
        <h5 className="text-red" style={{ margin: "8px 0" }}>
          Fallas {failures?.length ? `(${failures.length})` : ""}
        </h5>

        <ShowTable
          data={failures}
          columns={columns}
          pagination
          rows={10}
          stripedRows
          scrollable
          scrollHeight="flex"
          compact
          showTooltips
          emptyMessage="Sin fallas registradas"
        />
      </section>
    </div>
  );
};

export default InventoryFeedback;